/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  
  // Modals on Product & Collection Pages
 $(".call-price").click(function(){
  
    $("[ data-remodal-id='call-price']").show();
  });
  $("[data-remodal-id='call-price'] button").click(function(){
  
    $("[data-remodal-id='call-price']").hide();
  });
  $(".inquire-now-button").click(function(){
    var productName=$(".ProductMeta__Title").text();
    $("[id='Product Name']").val(productName);
  	$(".inquire-pop-up").show();
  });
  
  $(".inquire-pop-up .pswp__button--close").click(function(){
  
    $(".inquire-pop-up ").hide();
  });

//  sticky header changing
  if($(window).width() >= 768){
      $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {  
          $(".Header").addClass("Header--logoLeft");
          $(".Header").removeClass("Header--center");
          $('.CollectionToolbar.CollectionToolbar--top.CollectionToolbar--reverse').css('top','9%');
        } else {  
          $(".Header").removeClass("Header--logoLeft");
          $(".Header").addClass("Header--center");
          $('.CollectionToolbar.CollectionToolbar--top.CollectionToolbar--reverse').css('top','auto');
        }
    });
  }
  
});
(function () {
  function ytCommand(iframe, func, args) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({
      event: "command",
      func: func,
      args: args || []
    }), "*");
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".mute-toggle");
    if (!btn) return;

    // ✅ stop slider click
    e.preventDefault();
    e.stopPropagation();

    var active = document.querySelector("#MediaYoutube.is-selected") || btn.closest("#MediaYoutube") || document;
    var iframe = active.querySelector("iframe.yt-player") || document.querySelector("iframe.yt-player");
    if (!iframe) return;

    var onIcon = btn.querySelector("#sound-on") || btn.querySelector(".sound-on");
    var offIcon = btn.querySelector("#sound-off") || btn.querySelector(".sound-off");

    var muted = btn.getAttribute("data-muted") !== "false";

    if (muted) {
      ytCommand(iframe, "unMute");
      ytCommand(iframe, "setVolume", [100]);
      btn.setAttribute("data-muted", "false");
      if (onIcon) onIcon.style.display = "block";
      if (offIcon) offIcon.style.display = "none";
    } else {
      ytCommand(iframe, "mute");
      btn.setAttribute("data-muted", "true");
      if (onIcon) onIcon.style.display = "none";
      if (offIcon) offIcon.style.display = "block";
    }
  }, true); // ✅ capture phase helps beat Flickity handlers
})();
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var yt = document.getElementById("MediaYoutube");
    var actionList = document.querySelector(".Product__ActionList");
    if (!yt || !actionList) return;

    function toggleZoom() {
      if (yt.classList.contains("is-selected")) {
        actionList.classList.add("is-hidden");
      } else {
        actionList.classList.remove("is-hidden");
      }
    }

    // Run once on load
    toggleZoom();

    // Watch when slider selects/unselects the YouTube slide
    var obs = new MutationObserver(toggleZoom);
    obs.observe(yt, { attributes: true, attributeFilter: ["class"] });
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  var collectionHandle = "casual-pret-eid-edit26";

  // Match any notify text variants
  function isNotifyText(txt) {
    if (!txt) return false;
    txt = txt.trim().toLowerCase();
    return (
      txt === "notify me" ||
      txt === "notify me!" ||
      txt.includes("notify me") ||
      txt.includes("notify") && txt.includes("stock")
    );
  }

  // function replaceWithin(container) {
  //   if (!container) return;

  //   var nodes = container.querySelectorAll("a, button, span, div");
  //   nodes.forEach(function (el) {
  //     if (el.children && el.children.length) return;

  //     var t = (el.textContent || "").trim();
  //     if (!isNotifyText(t)) return;

  //     el.textContent = "Coming Soon";
  //     el.classList.add("coming-soon-badge");
  //     el.style.pointerEvents = "none";
  //     el.style.cursor = "default";
  //   });
  // }

  // 1) Always work on the target collection page (no fetch needed)
  function applyOnCollectionPage() {
    if (window.location.pathname.indexOf("/collections/" + collectionHandle) === -1) return;
    replaceWithin(document);
  }

  // 2) For homepage/other pages: fetch product handles from that collection
  function fetchHandles(cb) {
    var url = "/collections/" + collectionHandle + "/products.json?limit=250";
    fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var set = new Set();
        if (data && data.products) {
          data.products.forEach(function (p) { if (p && p.handle) set.add(p.handle); });
        }
        cb(set);
      })
      .catch(function () {
        cb(new Set());
      });
  }

  function applyByHandles(handleSet) {
    if (!handleSet || handleSet.size === 0) return;

    var links = document.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (link) {
      var href = link.getAttribute("href") || "";
      var m = href.match(/\/products\/([^/?#]+)/);
      if (!m) return;

      var handle = m[1];
      if (!handleSet.has(handle)) return;

      // find nearest product card container
      var card = link.closest(
        '[class*="ProductItem"], [class*="product"], [class*="card"], article, li, .grid__item, .CollectionItem'
      );
      if (!card) card = link.parentElement;

      replaceWithin(card);
    });
  }

  // Run now + retries (for late-loading sections)
  function runAll() {
    applyOnCollectionPage();

    fetchHandles(function (handles) {
      applyByHandles(handles);
    });
  }

  runAll();
  setTimeout(runAll, 600);
  setTimeout(runAll, 1500);
  setTimeout(runAll, 3000);

  // Watch DOM changes (homepage sections load dynamically)
  var obs = new MutationObserver(function () {
    runAll();
  });
  obs.observe(document.body, { childList: true, subtree: true });
});

(function () {
  var bridalPointer = { x: 0, y: 0, moved: false, tracking: false };

  function bridalWaLink(phone, message, title, pageUrl, image) {
    var parts = [];
    if (image) parts.push(image);
    if (message) parts.push(message);
    if (title) parts.push(title);
    if (pageUrl) parts.push(pageUrl);
    return "https://wa.me/" + phone + "?text=" + encodeURIComponent(parts.join("\n\n"));
  }

  function bridalPhotoLabel(index, total) {
    return "PHOTO " + index + " of " + total;
  }

  function bridalMetaLine(base, index, total) {
    var photo = bridalPhotoLabel(index, total);
    if (!base) return photo;
    return base + " · " + photo;
  }

  function bridalCardImages(card) {
    return (card.getAttribute("data-images") || "")
      .split("|")
      .map(function (src) { return src.trim(); })
      .filter(Boolean);
  }

  function setCardPhoto(card, index, total) {
    var photo = card.querySelector("[data-bridal-photo]");
    if (!photo) return;
    photo.setAttribute("data-bridal-live", "true");
    photo.textContent = bridalPhotoLabel(index, total);
  }

  function renderBridalModal(modal) {
    var items = modal._items || [];
    var index = modal._index || 0;
    var item = items[index] || {};
    var img = modal.querySelector("[data-bridal-modal-image]");
    var titleEl = modal.querySelector("[data-bridal-modal-title]");
    var metaEl = modal.querySelector("[data-bridal-modal-meta]");
    var view = modal.querySelector("[data-bridal-modal-view]");
    var wa = modal.querySelector("[data-bridal-modal-wa]");
    var prev = modal.querySelector("[data-bridal-nav='-1']");
    var next = modal.querySelector("[data-bridal-nav='1']");

    if (img) {
      img.src = item.src || "";
      img.alt = item.title || "";
    }
    if (titleEl) titleEl.textContent = item.title || "";
    if (metaEl) metaEl.textContent = bridalMetaLine(item.metaBase, index + 1, items.length);
    if (view) {
      if (item.page) {
        view.hidden = false;
        view.href = item.page;
      } else {
        view.hidden = true;
      }
    }
    if (wa && modal._phone) {
      wa.href = bridalWaLink(modal._phone, modal._message, item.title, item.page, item.src);
    }
    if (modal._card) setCardPhoto(modal._card, index + 1, items.length);
    if (prev) prev.hidden = items.length < 2;
    if (next) next.hidden = items.length < 2;
  }

  function openBridalModal(card, startIndex) {
    if (bridalPointer.moved) return;
    var section = card.closest(".BridalLooks");
    if (!section) return;
    var modal = section.querySelector("[data-bridal-modal]");
    if (!modal) return;

    var sources = bridalCardImages(card);
    if (!sources.length) return;
    var items = sources.map(function (src) {
      return {
        src: src,
        title: card.getAttribute("data-title") || "",
        metaBase: card.getAttribute("data-meta-base") || "",
        page: card.getAttribute("data-page") || ""
      };
    });

    modal._items = items;
    modal._card = card;
    modal._index = startIndex || 0;
    if (modal._index < 0 || modal._index >= items.length) modal._index = 0;
    modal._phone = section.getAttribute("data-wa-phone") || "";
    modal._message = section.getAttribute("data-wa-message") || "";
    modal._lastFocus = document.activeElement;
    renderBridalModal(modal);
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    var closeButton = modal.querySelector(".BridalLooks__ModalClose");
    if (closeButton) closeButton.focus();
  }

  function closeBridalModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
    if (modal._lastFocus && modal._lastFocus.focus) modal._lastFocus.focus();
  }

  function initBridalSlider(section) {
    var slider = section.querySelector("[data-bridal-slider]");
    if (!slider || slider.classList.contains("flickity-enabled") || typeof Flickity === "undefined") return;
    var config = {};
    try {
      config = JSON.parse(slider.getAttribute("data-bridal-slider") || "{}");
    } catch (error) {
      config = {};
    }
    new Flickity(slider, config);
  }

  function bindCardFrames(section) {
    section.querySelectorAll("[data-bridal-frames]").forEach(function (frames) {
      if (frames.getAttribute("data-bridal-bound")) return;
      frames.setAttribute("data-bridal-bound", "true");
      frames.addEventListener("pointerdown", function (event) {
        event.stopPropagation();
      });
      frames.addEventListener("scroll", function () {
        var card = frames.closest("[data-bridal-card]");
        if (!card) return;
        var width = frames.clientWidth || 1;
        var index = Math.round(frames.scrollLeft / width) + 1;
        var total = frames.querySelectorAll("[data-bridal-frame]").length;
        setCardPhoto(card, index, total);
      });
    });
  }

  function bindBridalPress(section) {
    section.querySelectorAll(".BridalLooks__Quick, .BridalLooks__Whatsapp").forEach(function (el) {
      if (el.getAttribute("data-bridal-bound")) return;
      el.setAttribute("data-bridal-bound", "true");
      el.addEventListener("pointerdown", function (event) {
        event.stopPropagation();
      });
    });
  }

  function initBridal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.classList && scope.classList.contains("BridalLooks")
      ? [scope]
      : scope.querySelectorAll(".BridalLooks");
    Array.prototype.forEach.call(sections, function (section) {
      initBridalSlider(section);
      bindBridalPress(section);
      bindCardFrames(section);
    });
  }

  function stepBridalModal(modal, direction) {
    if (!modal || !modal._items || modal._items.length < 2) return;
    var next = modal._index + direction;
    if (next < 0) next = modal._items.length - 1;
    if (next >= modal._items.length) next = 0;
    modal._index = next;
    renderBridalModal(modal);
  }

  document.addEventListener("pointerdown", function (event) {
    bridalPointer.moved = false;
    bridalPointer.tracking = false;
    bridalPointer.x = event.clientX;
    bridalPointer.y = event.clientY;
    if (event.target.closest(".BridalLooks__Media, .BridalLooks__ModalMedia")) {
      bridalPointer.tracking = true;
    }
  });

  document.addEventListener("pointermove", function (event) {
    if (!bridalPointer.tracking) return;
    if (Math.abs(event.clientX - bridalPointer.x) > 8 || Math.abs(event.clientY - bridalPointer.y) > 8) {
      bridalPointer.moved = true;
    }
  });

  document.addEventListener("pointerup", function (event) {
    var stage = event.target.closest(".BridalLooks__ModalMedia");
    if (stage && bridalPointer.moved) {
      var modal = stage.closest("[data-bridal-modal]");
      var delta = event.clientX - bridalPointer.x;
      if (Math.abs(delta) > 40) stepBridalModal(modal, delta < 0 ? 1 : -1);
    }
    bridalPointer.tracking = false;
  });

  document.addEventListener("click", function (event) {
    var quick = event.target.closest("[data-bridal-quick]");
    if (quick) {
      if (bridalPointer.moved) return;
      event.preventDefault();
      var card = quick.closest("[data-bridal-card]");
      var frameIndex = parseInt(quick.getAttribute("data-frame-index") || "0", 10);
      if (card) openBridalModal(card, isNaN(frameIndex) ? 0 : frameIndex);
      return;
    }

    var nav = event.target.closest("[data-bridal-nav]");
    if (nav) {
      event.preventDefault();
      stepBridalModal(nav.closest("[data-bridal-modal]"), parseInt(nav.getAttribute("data-bridal-nav"), 10));
      return;
    }

    var close = event.target.closest("[data-bridal-close]");
    if (close) {
      event.preventDefault();
      closeBridalModal(close.closest("[data-bridal-modal]"));
    }
  });

  document.addEventListener("wheel", function (event) {
    var modal = event.target.closest ? event.target.closest("[data-bridal-modal]") : null;
    if (!modal || modal.hidden) return;
    if (Math.abs(event.deltaX) < 8 && Math.abs(event.deltaY) < 8) return;
    event.preventDefault();
    var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    stepBridalModal(modal, delta > 0 ? 1 : -1);
  }, { passive: false });

  document.addEventListener("keydown", function (event) {
    var modal = document.querySelector(".BridalLooks__Modal:not([hidden])");
    if (!modal) return;
    if (event.key === "Escape") closeBridalModal(modal);
    if (event.key === "ArrowRight") stepBridalModal(modal, 1);
    if (event.key === "ArrowLeft") stepBridalModal(modal, -1);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initBridal(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var slider = event.target.querySelector("[data-bridal-slider]");
    if (!slider || typeof Flickity === "undefined" || !Flickity.data) return;
    var instance = Flickity.data(slider);
    if (instance) instance.destroy();
  });

  document.addEventListener("shopify:block:select", function (event) {
    var slider = event.target.closest("[data-bridal-slider]");
    if (!slider || typeof Flickity === "undefined" || !Flickity.data) return;
    var instance = Flickity.data(slider);
    var index = parseInt(event.target.getAttribute("data-slide-index"), 10);
    if (instance && !isNaN(index)) instance.select(index);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initBridal(document); });
  } else {
    initBridal(document);
  }
})();

